"use client";

import React from "react";
import { cn } from "@/lib/utils";

interface NavLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
  scrollToTop?: boolean;
}

export function NavLink({
  href,
  children,
  className,
  scrollToTop = true,
  onClick,
  ...props
}: NavLinkProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Check if it's the current page
    const currentPath = window.location.pathname;
    const linkPath = new URL(href, window.location.origin).pathname;

    if (currentPath === linkPath) {
      e.preventDefault();

      // Optionally scroll to top
      if (scrollToTop) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      // Call any additional onClick handler
      onClick?.(e);
    } else if (onClick) {
      onClick(e);
    }
  };

  return (
    <a href={href} className={cn(className)} onClick={handleClick} {...props}>
      {children}
    </a>
  );
}
